export default {
  pageTitle: 'Seminar Corrosion Science and Prevention',
  metaDescription: 'Undang PT Tokki Engineering and Fabrication (TEF) untuk mengisi seminar Corrosion Science and Prevention di perusahaan Anda.',
  hero: {
    eyebrow: 'TOKKI (TEF) CORROSION SEMINAR',
    titleGreen: 'Corrosion Science',
    titleBlack: 'and Prevention',
    subtitleLine1: 'Pengetahuan Praktis. Solusi Nyata.',
    subtitleLine2: 'Esok yang Lebih Aman dan Andal.',
    description: 'Tingkatkan keamanan, keandalan, dan usia pakai peralatan industri Anda dengan wawasan dari pengalaman TOKKI (TEF) di bidang teknik, pemilihan material, pengelasan, perbaikan, dan perawatan.',
    registerBtn: 'Ajukan Undangan',
    learnMoreBtn: 'Pelajari Lebih Lanjut',
    badgeSmall: 'Your Corrosion Doctor',
    badgeTagline1: 'Peralatan yang Andal',
    badgeTagline2: 'Industri yang Lebih Kuat',
    badgeTagline3: 'Indonesia yang Lebih Cerah',
  },
  about: {
    eyebrow: 'TENTANG SEMINAR',
    heading: 'Apa yang Akan Dipelajari',
    intro: 'Dalam seminar ini, kami menjelaskan topik-topik utama secara jelas dan praktis, berdasarkan pengalaman TOKKI (TEF) di lapangan.',
    topics: {
      t1: { title: 'Bagaimana dan mengapa korosi terjadi', desc: '' },
      t2: { title: 'Karakteristik dan perilaku korosi pada berbagai jenis logam', desc: '' },
      t3: { title: 'Jenis-jenis korosi', desc: '(korosi umum, pitting corrosion, crevice corrosion, dan stress corrosion cracking)' },
      t4: { title: 'Pemilihan material', desc: 'berdasarkan jenis fluida, suhu, tekanan, dan konsentrasi' },
      t5: { title: 'Metode pencegahan korosi, meliputi inspeksi, pemantauan, dan perawatan', desc: '' },
      t6: { title: 'Studi kasus dan solusi nyata', desc: 'pada penukar panas, bejana tekan, perpipaan, dan peralatan lainnya' },
    },
    customizationNote: 'Materi seminar dapat disesuaikan dengan industri, peralatan, kondisi operasional, dan kekhawatiran korosi spesifik perusahaan Anda.',
  },
  locations: {
    eyebrow: 'LOKASI SEMINAR',
    heading: 'Lokasi Seminar',
    description: 'Seminar dapat dilaksanakan di salah satu lokasi berikut:',
    clientSite: { title: 'Di pabrik atau fasilitas pelanggan' },
    tefOffice: { title: 'Di fasilitas TOKKI (TEF)' },
  },
  audience: {
    eyebrow: 'SIAPA YANG HARUS HADIR?',
    heading: 'Siapa yang Sebaiknya Hadir?',
    roles: [
      'Plant Manager',
      'Personel Perawatan & Peralatan',
      'Engineer',
      'Personel Inspeksi & QA/QC',
      'Tim Produksi & Operasi',
      'Personel Procurement',
      'Engineer Muda',
    ],
  },
  process: {
    eyebrow: 'DARI PERBAIKAN MENJADI PERLINDUNGAN',
    headingLine1: 'Dari Memperbaiki Setelah Rusak',
    headingLine2: 'Menjadi Melindungi Sebelum Rusak',
    description: 'Manajemen korosi bukan hanya soal memperbaiki peralatan setelah rusak. Penting untuk memahami risiko korosi dengan tepat dan bertindak sejak dini di setiap tahap:',
    steps: ['Desain', 'Pemilihan Material', 'Fabrikasi', 'Pengelasan', 'Inspeksi', 'Operasi', 'Perawatan'],
  },
  commitment: {
    eyebrow: 'KOMITMEN KAMI',
    heading: 'Komitmen Kami',
    description: 'TOKKI (TEF) melindungi aset berharga pelanggan kami dengan menerapkan pengetahuan manufaktur praktis dan pengalaman lapangan yang luas.',
    tagline: 'Masa Depan <b>INDONESIA</b>,<br>Dengan Teknologi <b>INDONESIA</b>.',
    subtagline: 'The Future of Indonesia,<br>with Indonesian Technology!',
  },
  contact: {
    eyebrow: 'ADA PERTANYAAN?',
    heading: 'Ada Pertanyaan?',
    description: 'Untuk informasi lebih lanjut mengenai seminar "Corrosion Science and Prevention", silakan hubungi Tim Business Development TOKKI (TEF).',
    button: 'Hubungi Tim Kami',
    tagline: 'Bersama, kita bangun industri yang lebih aman dan berkelanjutan.',
  },
  form: {
    heading: 'Register for the Seminar',
    subheading: 'Lengkapi data di bawah ini dan tim kami akan menghubungi Anda untuk detail lebih lanjut',
    fullName: 'Nama Lengkap',
    fullNamePlaceholder: 'Masukkan nama lengkap Anda',
    companyName: 'Nama Perusahaan',
    companyNamePlaceholder: 'Masukkan nama perusahaan Anda',
    jobTitle: 'Jabatan',
    jobTitlePlaceholder: 'Masukkan jabatan Anda',
    industry: 'Industri',
    industryPlaceholder: 'Pilih industri',
    industries: ['Oil & Gas', 'Petrokimia', 'Farmasi', 'Pupuk', 'Pembangkit Listrik', 'Lainnya'],
    email: 'Email',
    emailPlaceholder: 'Masukkan alamat email Anda',
    phoneNumber: 'Nomor Telepon',
    phoneNumberPlaceholder: 'Masukkan nomor telepon Anda',
    preferredDate: 'Tanggal yang Diinginkan',
    participants: 'Perkiraan Jumlah Peserta',
    participantsPlaceholder: 'Jumlah peserta',
    location: 'Lokasi Seminar',
    locationPlaceholder: 'Pilih lokasi',
    locationClientSite: 'Di lokasi perusahaan Anda',
    locationTefOffice: 'Di fasilitas TEF',
    message: 'Pesan / Minat Spesifik',
    messagePlaceholder: 'Sampaikan minat atau pertanyaan spesifik Anda... (opsional)',
    submit: 'Submit Registration',
    pleaseWait: 'Mohon Tunggu...',
    successMessage: 'Pengajuan undangan seminar berhasil dikirim. Tim kami akan segera menghubungi Anda.',
    errorMessage: 'Pengajuan gagal dikirim. Silakan coba lagi.',
    requiredNotice: 'Semua kolom bertanda * wajib diisi',
    confidentialNotice: 'Informasi Anda kami jaga kerahasiaannya',
  },
};
